import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { UserPermission as GenesysUserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';

@Component({
  selector: 'app-genesys-email-footer-control-panel',
  templateUrl: './genesys-email-footer-control-panel.component.html',
  styleUrls: ['./genesys-email-footer-control-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailFooterControlPanelComponent {
  @Input() isInteractionDisabled: boolean;
  @Input() isExpanded: boolean;

  @Output() reply = new EventEmitter();
  @Output() forward = new EventEmitter();
  @Output() replyAll = new EventEmitter();
  @Output() confirmation = new EventEmitter();
  @Output() wrapUp = new EventEmitter();
  @Output() openTransferPanel = new EventEmitter();

  readonly gcUserPermission = GenesysUserPermission;

  onReply(): void {
    this.reply.emit();
  }
  onForward(): void {
    this.forward.emit();
  }
  onReplyAll(): void {
    this.replyAll.emit();
  }
  handleConfirmation(): void {
    this.confirmation.emit();
  }
  onOpenWrapUpPanel(): void {
    this.wrapUp.emit();
  }
  onOpenTransferPanel(): void {
    this.openTransferPanel.emit();
  }
}
